<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p13" title="13">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="chocolate_cherry_bread">Chocolate-Cherry Bread</h2>
<p class="recipetime"><span class="yield_black">1 loaf (12 slices)</span> <span class="separater">|</span> Prep Time: 15 Minutes <span class="separater">|</span> Start to Finish: 2 Hours 40 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">2</span> cups all-purpose flour</li>
<li class="list"><span class="qty1">1½</span> teaspoons baking powder</li>
<li class="list"><span class="qty1">½</span> teaspoon baking soda</li>
<li class="list"><span class="qty1">¼</span> teaspoon salt</li>
<li class="list"><span class="qty1">¾</span> cup sugar</li>
<li class="list"><span class="qty1">½</span> cup butter, softened</li>
<li class="list"><span class="qty1">2</span> eggs</li>
<li class="list"><span class="qty1">1</span> teaspoon almond extract</li>
<li class="list"><span class="qty1">1</span> teaspoon vanilla</li>
<li class="list"><span class="qty1">1</span> container (8 oz) sour cream</li>
<li class="list"><span class="qty1">½</span> cup chopped dried cherries</li>
<li class="list"><span class="qty1">½</span> cup bittersweet or dark chocolate chips</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Heat oven to 350°F. Grease 9x5-inch loaf pan with shortening; lightly flour. In medium bowl, mix flour, baking powder, baking soda and salt; set aside.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In large bowl, beat sugar and butter with electric mixer on medium speed until light and fluffy, about 2 minutes. Beat in eggs until well mixed. Beat in almond extract and vanilla. Alternately add flour mixture and sour cream, beating on low speed just until blended after each addition. Stir in cherries and chocolate chips. Spread batter in pan.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> Bake 1 hour 10 minutes to 1 hour 15 minutes or until toothpick inserted in center comes out clean. Cool 10 minutes; remove from pan to cooling rack. Cool completely, about 1 hour. Wrap tightly and store at room temperature up to 4 days, or refrigerate.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> Freeze tightly wrapped up to 3 months. Thaw at room temperature.</p>
<p class="recipe_info"><span class="nutr_bold">1 Slice:</span> Calories 310; Total Fat 15g (Saturated Fat 9g, Trans Fat 0g); Cholesterol 60mg; Sodium 260mg; Total Carbohydrate 39g (Dietary Fiber 1g); Protein 4g <span class="nutr_bold">Exchanges:</span> 1½ Starch, 1 Other Carbohydrate, 3 Fat <span class="nutr_bold">Carbohydrate Choices:</span> 2½</p>
<p class="recipe_note"><span class="tips">Fresh Idea</span> Gifting alert—this bread makes a perfect present for the holidays, new neighbors, or just about any occasion. You’ll probably want to double the recipe, especially because it freezes beautifully!</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p013.vue?1c8575c7